// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/static/css/styles.css
// module id = 27
// module chunks = 1